"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResendLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultTranslations = require("../../constants/defaultTranslations");
var _TranslationKey = require("../../models/TranslationKey");
var _FormattedMessage = require("../FormattedMessage");
var _VerifyStyled = require("./VerifyStyled");
var _jsxRuntime = require("react/jsx-runtime");
const ResendLink = props => {
  const {
    handleResendCode,
    isResendDisabled
  } = props;
  if (isResendDisabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: _TranslationKey.TranslationKey.resendInMinute,
      defaultMessage: _defaultTranslations.defaultTranslations.resendInMinute
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifyStyled.AnchorResend, {
    role: "presentation",
    onClick: handleResendCode,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: _TranslationKey.TranslationKey.resend,
      defaultMessage: _defaultTranslations.defaultTranslations.resend
    })
  });
};
exports.ResendLink = ResendLink;
//# sourceMappingURL=ResendLink.js.map